var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.67253 24.9998H24.4041C24.5824 24.9998 24.7535 24.929 24.8796 24.8029C25.0057 24.6767 25.0766 24.5057 25.0766 24.3273C25.0766 24.1489 25.0057 23.9779 24.8796 23.8518C24.7535 23.7256 24.5824 23.6548 24.4041 23.6548H1.67253C1.49416 23.6548 1.3231 23.7256 1.19698 23.8518C1.07086 23.9779 1 24.1489 1 24.3273C1 24.5057 1.07086 24.6767 1.19698 24.8029C1.3231 24.929 1.49416 24.9998 1.67253 24.9998Z",
    fill: "#1B224C",
    stroke: "#1B224C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.96075 19.9453C10.5289 19.7863 11.0473 19.4854 11.4672 19.071L24.2991 6.23908C24.7385 5.79792 24.9853 5.20061 24.9853 4.57793C24.9853 3.95525 24.7385 3.35794 24.2991 2.91678L23.0347 1.66587C22.5873 1.23849 21.9924 1 21.3736 1C20.7548 1 20.1599 1.23849 19.7124 1.66587L6.88056 14.4843C6.46539 14.9015 6.16834 15.4213 6.01972 15.9908L5.02437 19.7031C4.97715 19.8727 4.97593 20.0518 5.02085 20.222C5.06576 20.3922 5.15519 20.5474 5.27994 20.6716C5.47032 20.8588 5.72585 20.9648 5.99282 20.9675L9.96075 19.9453ZM10.5122 18.116C10.2643 18.3684 9.95301 18.5496 9.61103 18.6405L8.30632 18.9903L6.96126 17.6452L7.31098 16.3405C7.40506 15.9998 7.58579 15.6893 7.83555 15.4393L8.34668 14.9416L11.0233 17.6183L10.5122 18.116ZM11.9783 16.6633L9.30167 13.9866L18.3539 4.93437L21.0306 7.61105L11.9783 16.6633ZM23.3441 5.29754L21.9856 6.65605L19.3089 3.97938L20.6674 2.60742C20.7609 2.51355 20.872 2.43907 20.9944 2.38825C21.1167 2.33743 21.2479 2.31127 21.3803 2.31127C21.5128 2.31127 21.644 2.33743 21.7663 2.38825C21.8886 2.43907 21.9997 2.51355 22.0932 2.60742L23.3441 3.87177C23.5317 4.06161 23.6369 4.31776 23.6369 4.58466C23.6369 4.85156 23.5317 5.1077 23.3441 5.29754Z",
    fill: "#1B224C",
    stroke: "#1B224C",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8961f43f4392c6e37901516a92344209.svg";
export { ForwardRef as ReactComponent };